import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./dataTableCellItem.html";
class DataTableCellItem extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = void 0;
    this.tooltip = void 0;
    this.handleMouseOver = cellElement => {
      const {
        clientY: topPosition
      } = cellElement;
      const cellPosition = topPosition - 50;
      const element = this.template.querySelector('.data-cell-item_tooltip');
      if (element && element.textContent) {
        this.showTooltip(element, cellPosition);
      }
    };
    this.handleMouseOut = () => {
      const element = this.template.querySelector('.data-cell-item_tooltip');
      this.hideTooltip(element);
    };
    this.showTooltip = (element, cellPosition) => {
      element.classList.remove('slds-fall-into-ground');
      element.classList.add('slds-slide-from-bottom-to-top');
      element.style.cursor = 'pointer';
      element.style.top = cellPosition.toString() + 'px';
    };
    this.hideTooltip = element => {
      element.classList.add('slds-fall-into-ground');
      element.classList.remove('slds-slide-from-bottom-to-top');
      element.style.cursor = 'auto';
    };
  }
}
_registerDecorators(DataTableCellItem, {
  publicProps: {
    label: {
      config: 0
    },
    tooltip: {
      config: 0
    }
  },
  fields: ["handleMouseOver", "handleMouseOut", "showTooltip", "hideTooltip"]
});
export default _registerComponent(DataTableCellItem, {
  tmpl: _tmpl
});